import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import {Route, Routes, useParams} from "react-router-dom";
import ModulePage from "../components/module-page";
import Node from "../components/node";
import CategoriesDomain from "../domains/CategoriesDomain";
import ItemContainersDomain from "../domains/ItemContainersDomain";
import SearchDomain from "../domains/SearchDomain";
import ViewersDomain from "../domains/ViewersDomain";
import {ItemContainerTypes} from "../model/item-containers-models/itemContainerType";
import {catalogSelector} from "../state/catalog/catalogSelectors";
import {hubStateSelector} from "../state/hub/hubSelectors";
import {moduleConfigsSelector} from "../state/module-configs/moduleConfigsSelectors";
import {nodeCustomHomePageIdSelector, nodeSelector} from "../state/node/nodeSelectors";

const NodeRouter = ({isDefault}) => {
  const {nodeCode} = useParams();

  const moduleConfigs = useSelector(moduleConfigsSelector);
  const hub = useSelector(hubStateSelector);
  const node = useSelector(nodeSelector);
  const catalog = useSelector(catalogSelector);

  const areNodeAndCatalogOk =
    node && catalog && node.code.toLowerCase() === nodeCode.toLowerCase() && node.nodeId === catalog.nodeId;

  const nodeHavingCode = hub.nodes.find(({code}) => code.toLowerCase() === nodeCode.toLowerCase());
  const nodeHomePageId = useSelector(nodeCustomHomePageIdSelector(nodeHavingCode.nodeId));

  return (
    areNodeAndCatalogOk && (
      <Fragment>
        <Routes>
          <Route
            path="/"
            element={
              nodeHomePageId ? (
                <ItemContainersDomain
                  itemContainerId={nodeHomePageId}
                  hideBreadcrumbs={true}
                  nodeCode={nodeCode}
                  isDefault={isDefault}
                  itemContainerType={ItemContainerTypes.CustomPage}
                />
              ) : (
                <Node nodeCode={nodeCode} isDefault={isDefault} />
              )
            }
          />
          {moduleConfigs.modules.includes("dashboard") && (
            <Route
              path="/dashboards"
              element={
                <ItemContainersDomain
                  nodeCode={nodeCode}
                  isDefault={isDefault}
                  itemContainerType={ItemContainerTypes.Dashboard}
                />
              }
            />
          )}
          {moduleConfigs.modules.includes("custom-page") && (
            <Route
              path="/pages/:id"
              element={
                <ItemContainersDomain
                  nodeCode={nodeCode}
                  isDefault={isDefault}
                  itemContainerType={ItemContainerTypes.CustomPage}
                />
              }
            />
          )}
          <Route
            path="/search"
            element={<SearchDomain hub={hub} node={node} nodeCode={nodeCode} isDefault={isDefault} catalog={catalog} />}
          />
          <Route
            path="/categories/*"
            element={
              <CategoriesDomain hub={hub} node={node} catalog={catalog} nodeCode={nodeCode} isDefault={isDefault} />
            }
          />
          {(moduleConfigs.nodeRoutes || []).map(({id, route, component, fallback, ...props}) => {
            return (
              <Route
                key={id}
                path={`/${route}/*`}
                element={
                  <ModulePage
                    moduleId={id}
                    moduleComponent={component}
                    moduleFallback={fallback}
                    isDefault={isDefault}
                    {...props}
                  />
                }
              />
            );
          })}
          <Route
            path="/:packageId"
            element={
              <ViewersDomain
                hub={hub}
                node={node}
                nodeCode={nodeCode}
                isDefault={isDefault}
                catalog={catalog}
                categoryPath={[]}
              />
            }
          />
        </Routes>
      </Fragment>
    )
  );
};

export default NodeRouter;
